import React from "react";
import { useReveal } from "../../hooks/useReveal";

const bgByColor = {
    yellow: "bg-tape",
    green: "bg-highlight",
    pink: "bg-[#F7D5D2]",
    blue: "bg-[#CDE0EE]",
};

const StickyNote = ({
    children,
    color = "yellow",
    rotation = "rotate-1",
    pin = true,
    className = "",
    testId,
}) => {
    const [ref, visible] = useReveal();
    return (
        <div
            ref={ref}
            data-testid={testId}
            className={`reveal-up ${visible ? "is-visible" : ""} relative p-8 sm:p-10 scrap-shadow ${bgByColor[color] || bgByColor.yellow} ${rotation} ${className}`}
        >
            {pin && (
                <span
                    aria-hidden="true"
                    className="pin-dot -top-2 left-1/2 -translate-x-1/2"
                />
            )}
            {children}
        </div>
    );
};

export default StickyNote;
